<template>
  <div class=" container py-4">
    Tela inicial ADMS e corretores
  </div>
</template>

<script setup>

</script>

<style scoped>
.container { max-width: 80%; }
</style>
